"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProductsApp_1 = require("./createProductsApp");
const ProductList_laitepalvelu_1 = require("./ProductList-laitepalvelu");
const BrandList_laitepalvelu_1 = require("./BrandList-laitepalvelu");
const CategoryList_1 = require("./CategoryList");
exports.default = (0, createProductsApp_1.default)({
    ProductListComponent: ProductList_laitepalvelu_1.default,
    BrandListComponent: BrandList_laitepalvelu_1.default,
    CategoryListComponent: CategoryList_1.default,
    useProductFilterRoutes: true,
});
